export const msalConfig = {
  auth: {
    clientId: process.env.CLIENT_ID
  }
}

export const userRequest = {
  scopes: ['User.Read']
}
